import React from 'react';
import { LoaderSpinner } from 'carbon-react/lib/components/loader-spinner';
import { LoaderSpinnerSizes } from 'carbon-react/lib/components/loader-spinner/loader-spinner.config';

export interface UILoaderSpinnerProps {
  label?: string;
  size?: LoaderSpinnerSizes;
}

export const UILoaderSpinner = ({ label, size }: UILoaderSpinnerProps) => (
  <LoaderSpinner showSpinnerLabel={!!label} spinnerLabel={label} size={size} />
);
